import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import immoweltMobile from '@mfe-presentation/assets/images/portals/immowelt/web-to-app-banner-mobile.webp';
import immoweltTablet from '@mfe-presentation/assets/images/portals/immowelt/web-to-app-banner-tablet.webp';
import immoweltDesktop from '@mfe-presentation/assets/images/portals/immowelt/web-to-app-banner-desktop.webp';
import immonetMobile from '@mfe-presentation/assets/images/portals/immonet/web-to-app-banner-mobile.webp';
import immonetTablet from '@mfe-presentation/assets/images/portals/immonet/web-to-app-banner-tablet.webp';
import immonetDesktop from '@mfe-presentation/assets/images/portals/immonet/web-to-app-banner-desktop.webp';
import selogerMobile from '@mfe-presentation/assets/images/portals/seloger_legacy/web-to-app-banner-mobile.webp';
import selogerTablet from '@mfe-presentation/assets/images/portals/seloger_legacy/web-to-app-banner-tablet.webp';
import selogerDesktop from '@mfe-presentation/assets/images/portals/seloger_legacy/web-to-app-banner-desktop.webp';
// TODO Use new images from ../portals/seloger/.. when ready ETA april 2025
// https://avivgroup.atlassian.net/browse/VEGA-2043
// https://avivgroup.atlassian.net/browse/VEGA-2091

export const imagePaths: Partial<
    Record<
        Portal,
        {
            mobile: string;
            tablet: string;
            desktop: string;
        }
    >
> = {
    [Portal.ImmoWelt]: {
        mobile: immoweltMobile,
        tablet: immoweltTablet,
        desktop: immoweltDesktop,
    },
    [Portal.Immonet]: {
        mobile: immonetMobile,
        tablet: immonetTablet,
        desktop: immonetDesktop,
    },
    [Portal.SeLoger]: {
        mobile: selogerMobile,
        tablet: selogerTablet,
        desktop: selogerDesktop,
    },
};
